// W38 (2026-10-20): default fetch for the API clients.
//
// RuntimeApiClient, MyActivityCompositeClient and MyActivityClient used
// to default `fetchImpl` to the bare `fetch` and then call
// `this.fetchImpl(url, init)`. In a browser that invokes window.fetch
// with the client object as receiver, which Chrome rejects with
//   "Failed to execute 'fetch' on 'Window': Illegal invocation"
// (MEASURED on the live Colic Coverage, Gifts and Relationships screens
// on 2026-10-20, the first time these code paths ran in production: before
// W38 injected the runtime base URL, useScreenRuntime() returned null and
// no client was ever constructed there). Unit tests never saw it because
// they inject fetchImpl, and Node's global fetch does not check its
// receiver.
//
// Resolving the global at call time (rather than `fetch.bind(globalThis)`
// at import time) keeps vi.stubGlobal('fetch', ...) in tests effective
// regardless of module evaluation order.
export const defaultFetch: typeof fetch = (input, init) => globalThis.fetch(input, init);
